import {
  $getReferenceIsgUrls,
  $getSupplierParameters,
  IReferenceIsgUrl,
} from "../requests"

import { ActionTypes } from "./act_types"
import { getUserRole, getTranslationsByScope, DropitState } from "../reducers"
import { toastr } from "react-redux-toastr"
import { responseType, transform } from "../../utils/http-res-handler"

export const fetchIsgUrls =
  () => (dispatch: (callback: object) => void, getState: () => DropitState) => {
    return $getReferenceIsgUrls()
      .then((res) =>
        transform(
          res,
          getTranslationsByScope(getState(), "toastrLabels"),
          responseType.json
        )
      )
      .then((response: IReferenceIsgUrl[]) => {
        dispatch({
          urls: response,
          type: ActionTypes.FETCH_ISG_URLS,
        })
      })
      .catch((err) => {
        toastr.error(
          err.message ? err.message : "Impossible de contacter le server.",
          ""
        )
        return err
      })
  }
